module.exports = __webpack_public_path__ + "static/media/ending-lines.c3f79862.png";